import { render, staticRenderFns } from "./CreateExtraBatchModal.vue?vue&type=template&id=2234543f&"
import script from "./CreateExtraBatchModal.vue?vue&type=script&lang=js&"
export * from "./CreateExtraBatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports